
const AbstractVisual = () => {
  return (
    <div className="w-full h-full p-8 bg-card/50 rounded-lg border border-border flex items-center justify-center">
      <div className="relative w-48 h-48">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-primary/20 animate-pulse"
            style={{
              width: `${(i + 1) * 30}px`,
              height: `${(i + 1) * 30}px`,
              top: `50%`,
              left: `50%`,
              transform: `translate(-50%, -50%) rotate(${i * 15}deg) scale(${(i + 1) * 0.5})`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-primary/80" />
      </div>
    </div>
  );
};

export default AbstractVisual;
